// import layout from '@/layouts/demo-layout.vue'
import layout from '@/layouts/expandinggrid-dallym-teams.vue'
import parts from './parts.json'
import importAllImages from '@/functions/importAllImages.js'
import teams from '@/nrl-teams'


export default {
  version: 0, // * used to track minor version revisions

  // Controls the layout component to use
  layout,
  showDump: false,
  custom: {},

  // Options to control the layout/app - Not implemented in all apps
  // Can be seen in showbags/player ratings where options for sorting/fitering are passed in
  options: {
    theme: 'dark',
  },

  teams,

  // !! WARNING !!
  // This function imports all images, regardless of whether they are used or not
  // be sure to move unused images to a different location
  allImages: importAllImages(require.context('../../images', false, /\.js/)),
  badges: importAllImages(require.context('../../images', false, /\.png/)),


  // Main title/intro content - all items are optional
  header: {
    title: 'Meet the full Everest field',
    intro: false,
    decorations: {},
    // Can support small illsutration (calorie / super calculator)
    // Imported as svg modules
    // illustration: null,
  },

  // Array of objects, itterated over to fill out list-like content
  // Requirements of each object are typically governed by the layout/components
  parts,
  overlayColor: '#2F56CD'
}



// WEBPACK FOOTER //
// ./src/content/projects/1003-everest-horses/index.js